import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-243" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-244" data-mp="3fxkx4ig9ujno">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-245" data-mp="3b1chl3y5wofz">
          Testimonials from Educators Using This Teacher Ready
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-246" data-mp="3205ziqfv75km">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-line bg-panel p-6 text-ink shadow-card" data-id="element-247" data-mp="2x1uq2gthex2x" data-mpi={index}>
              <div className="flex text-gold" aria-label="5 out of 5 stars" data-id="element-248" data-mp="h4dc6jitvk34">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-249" data-mp="m2opj48c0cq3" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-250" data-mp="c622c8sj99kw">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-251" data-mp="zw65kf1t77bd">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-forest text-sm font-extrabold text-white" data-id="element-252" data-mp="14v99fw61z7hr">
                  {initials}
                </span>
                <span data-id="element-253" data-mp="v5g2j8guvgju">
                  <b className="block text-sm text-ink" data-id="element-254" data-mp="v4xz9rvs022f">{name}</b>
                  <small className="text-xs text-muted" data-id="element-255" data-mp="1ivadfkhm6v1g">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}